import { render, staticRenderFns } from "./DetailAndResultLabOrder.vue?vue&type=template&id=1bad80da&scoped=true"
import script from "./DetailAndResultLabOrder.vue?vue&type=script&lang=js"
export * from "./DetailAndResultLabOrder.vue?vue&type=script&lang=js"
import style0 from "./DetailAndResultLabOrder.vue?vue&type=style&index=0&id=1bad80da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bad80da",
  null
  
)

export default component.exports